// Repeat bookings (beu-node-v2 /api/v2/booking-series). Every visit is an
// ordinary diary booking; these calls check the dates, make the series,
// read it for the booking panel, stop, pause, undo and change it.
import axios from 'axios'
import API from '../config/API'

const headers = () => ({
  'Content-Type': 'application/json',
  authorization: 'Basic YmV1YXBwOmJldWFwcA==',
  accessToken: `${localStorage.getItem('accessToken')}`,
})
const data = (res) => {
  const body = res && res.data
  if (!body || body.statusCode !== 1) {
    const msg = (body && body.error && (body.error.responseMessage || body.error.message)) || (body && body.responseData && body.responseData.message) || 'Something went wrong'
    throw new Error(msg)
  }
  return body.responseData
}

export const bookingSeriesService = {
  check: (params) => axios.post(`${API.BOOKING_SERIES}/check`, params, { headers: headers() }).then(data),
  create: (params) => axios.post(API.BOOKING_SERIES, params, { headers: headers() }).then(data),
  get: (id) => axios.get(`${API.BOOKING_SERIES}/${encodeURIComponent(id)}`, { headers: headers() }).then(data),
  // After a visit was edited: the visits after it change to match
  updateFollowing: (bookingId) => axios.post(`${API.BOOKING_SERIES}/update-following`, { bookingId }, { headers: headers() }).then(data),
  // Repeats whose last booked visit is within four weeks (for the bell's To do)
  endingSoon: () => axios.get(`${API.BOOKING_SERIES}/ending-soon`, { headers: headers() }).then(data),
  stop: (bookingId, cancel, refundDeposit = 0) => axios.post(`${API.BOOKING_SERIES}/stop`, { bookingId, cancel, refundDeposit }, { headers: headers() }).then(data),
  // Skip the visits between two dates (inclusive), keep the repeat going.
  // The client gets one message listing the dates.
  pause: (bookingId, from, to) => axios.post(`${API.BOOKING_SERIES}/pause`, { bookingId, from, to }, { headers: headers() }).then(data),
  // A repeat just booked by mistake: every visit removed, nothing sent.
  // Only for 10 minutes after booking it.
  undo: (seriesId) => axios.post(`${API.BOOKING_SERIES}/undo`, { seriesId }, { headers: headers() }).then(data),
  // Change how often (or when it ends) from this visit on: the check has
  // the same shape as check(), then change-rule rebooks the later visits
  changeRuleCheck: (params) => axios.post(`${API.BOOKING_SERIES}/change-rule/check`, params, { headers: headers() }).then(data),
  changeRule: (params) => axios.post(`${API.BOOKING_SERIES}/change-rule`, params, { headers: headers() }).then(data),
}
